o2-swiper {
  display: block;
}

o2-swiper[direction='vertical'] {
  height: 100%;

  .o2-swiper {
    height: 100%;
  }
}

.o2-swiper {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
  width: 100%;

  .o2-swiper__wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
    transform: translate3d(0px, 0, 0);
  }

  .o2-swiper__slide {
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
    transition-property: transform;
  }

  .o2-swiper__button-prev,
  .o2-swiper__button-next {
    position: absolute;
    top: 50%;
    font-size: 24px;
    margin-top: calc(0px - (40px / 2));
    z-index: 10;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--swiper-navigation-color, var(--swiper-theme-color));

    &.swiper-button-disabled {
      opacity: 0.35;
      cursor: auto;
      pointer-events: none;
    }
  }
  .o2-swiper__button-prev {
    left: 10px;
    right: auto;
  }
  .o2-swiper__button-next {
    right: 10px;
    left: auto;
  }

  .o2-swiper__pagination {
    position: absolute;
    text-align: center;
    transition: 300ms opacity;
    transform: translate3d(0, 0, 0);
    z-index: 10;

    &.swiper-pagination-hidden {
      opacity: 0;
    }
  }

  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 50%;
    background: #000;
    opacity: 1;
    background: var(--o2-gray-light, #{$gray-light});

    @at-root button#{&} {
      border: none;
      margin: 0;
      padding: 0;
      box-shadow: none;
      appearance: none;
    }
    .swiper-pagination-clickable {
      cursor: pointer;
    }

    &:only-child {
      display: none !important;
    }
  }

  .swiper-pagination-bullet-active {
    opacity: 1;
    background: var(--o2-blue-brand, #{$blue-brand});
  }
}

.o2-swiper.swiper-vertical {
  > .o2-swiper__wrapper {
    flex-direction: column;
  }

  o2-swiper-slide {
    height: auto !important;
  }

  .o2-swiper__button-prev {
    left: auto;
    transform: rotate(90deg);
    top: 1rem;
    bottom: auto;
  }

  .o2-swiper__button-next {
    right: auto;
    transform: rotate(90deg);
    bottom: 0;
    top: auto;
  }

  .o2-swiper__pagination {
    position: absolute;
    right: 1rem;
    top: 50%;
    transition: 300ms opacity;
    z-index: 10;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    transform: translateY(-50%);

    &.swiper-pagination-hidden {
      opacity: 0;
    }
  }
}

/* Common Styles */
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-horizontal > .swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal {
  bottom: 10px;
  left: 0;
  width: 100%;
}

.swiper-horizontal > .swiper-pagination-bullets,
.swiper-pagination-horizontal.swiper-pagination-bullets {
  .swiper-pagination-bullet {
    margin: 0 4px;
  }
}

.swiper-pointer-events {
  touch-action: pan-y;
  &.swiper-vertical {
    touch-action: pan-x;
  }
}

.swiper-vertical.swiper-css-mode {
  > .swiper-wrapper {
    scroll-snap-type: y mandatory;
  }
}

o2-tabs {
  .o2-swiper {
    margin-bottom: 0;
  }
}

.swiper-pagination-lock {
  display: none !important;
}

.o2-swiper.slides-per-view-auto o2-swiper-slide {
  width: auto;
}

.swiper-fade.swiper-free-mode .o2-swiper__slide {
  transition-timing-function: ease-out;
}
.swiper-fade .o2-swiper__slide {
  pointer-events: none;
  transition-property: opacity;
}
.swiper-fade .o2-swiper__slide .o2-swiper__slide {
  pointer-events: none;
}
.swiper-fade .swiper-slide-active,
.swiper-fade .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}
